import { PAGE_URL, PERMISSION_KEY } from "../services/constant";

const apiKeyPermissionGroupCredentialsMenuRegistry = {
    core_apiKeyPermissionGroupCredentials: {
        label: "API Key Permission Group Credentials",
        link: PAGE_URL.API_KEY_PERMISSION_GROUP_CREDENTIALS_PAGE,
        key: PAGE_URL.API_KEY_PERMISSION_GROUP_CREDENTIALS_PAGE,
        resourceKey: PERMISSION_KEY
    }
}

export default apiKeyPermissionGroupCredentialsMenuRegistry;
